import * as $ from 'jquery';
import 'bootstrap';

export class iconThumbnail{
  showMoreParters(): any{
    var currentSize = 0;
    // auto-hide function
    var resize = function() {
      currentSize = $(window).width();
      if( currentSize > 767 ) {
        // console.log('Greater than 767');
      } else {
        let _self = this;
	    let $showmorePartnersBtn: any = $('.show-more--partners');
	    let $totalPartners: any = $('.enrich_featured_partners__card').length;
	    let $limitPartners: any = $('.enrich_featured_partners__cards').attr('data-item--showonload');
	    let $showItem:any = $('.show-morepartners--content .no-of--items');
	    let $totalPartnersItem: any = $('.show-morepartners--content .total-items');

	    $(".enrich_featured_partners__card:lt("+$limitPartners+")").show();

	    let $visiblePartners: any = $('.enrich_featured_partners__card:visible').length;
	    $showItem.html($visiblePartners);
	    $totalPartnersItem.html($totalPartners);

	    $showmorePartnersBtn.on('click', (e:any) =>{
	      e.preventDefault();
	      let $nextShowItems: any = $('.enrich_featured_partners__cards').attr('data-item--showeachclick');
	      let $shown: any = $('.enrich_featured_partners__card:visible').length+ parseInt($nextShowItems);
	      if($shown < $totalPartners){
	        $(".enrich_featured_partners__card:lt("+$shown+")").show();
	        let $visiblePartners: any = $('.enrich_featured_partners__card:visible').length;
	      $showItem.html($visiblePartners);
	      $totalPartnersItem.html($totalPartners);
	      } else {
	        $(".enrich_featured_partners__card:lt("+$totalPartners+")").show();
	        $showmorePartnersBtn.hide();
	        let $visiblePartners: any = $('.enrich_featured_partners__card:visible').length;
	      $showItem.html($visiblePartners);
	      $totalPartnersItem.html($totalPartners);
	      }
	    });
      }
    };
    resize();
    $(window).resize(function(){
      if((currentSize + 10) < $(window).width()){
        resize();
      }
    });
  }
}

let scope:Element = document.querySelector('.enrich_featured_partners');
if (scope){
	try {
	let iconthumbnail = new iconThumbnail();
	  	iconthumbnail.showMoreParters();
	} catch(e) {console.error(e);}
}
